import {map} from 'lodash';

export default class MatchMedia {

    constructor(){
        this.breakpoints = {
            xs: '0',
            sm: '576px',
            md: '768px',
            lg: '992px',
            xl: '1200px',
            xxl: '1380px',
            xxxl: '1560px'
        }
    }

    match(breakpoint) {
        return window.matchMedia(breakpoint).matches;
    }

    extract(breakpoint) {
        let result;
        map(this.breakpoints, (value, key) => {
            if (key === breakpoint) {
                result = value;
            }
        });
        return result;
    }

    up(breakpoint) {
        return this.match(`(min-width: ${this.extract(breakpoint)})`);
    }

    down(breakpoint) {
        return this.match(`(max-width: ${this.extract(breakpoint)})`);
    }
}